/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingQuotaDefinition } from './BillingQuotaDefinition';
import {
    BillingQuotaDefinitionFromJSON,
    BillingQuotaDefinitionFromJSONTyped,
    BillingQuotaDefinitionToJSON,
    BillingQuotaDefinitionToJSONTyped,
} from './BillingQuotaDefinition';

/**
 * 
 * @export
 * @interface BillingPackageQuotaOverride
 */
export interface BillingPackageQuotaOverride {
    /**
     * 
     * @type {number}
     * @memberof BillingPackageQuotaOverride
     */
    billingQuotaDefinitionId: number;
    /**
     * 
     * @type {number}
     * @memberof BillingPackageQuotaOverride
     */
    value: number;
    /**
     * 
     * @type {BillingQuotaDefinition}
     * @memberof BillingPackageQuotaOverride
     */
    billingQuotaDefinition?: BillingQuotaDefinition;
}

/**
 * Check if a given object implements the BillingPackageQuotaOverride interface.
 */
export function instanceOfBillingPackageQuotaOverride(value: object): value is BillingPackageQuotaOverride {
    if (!('billingQuotaDefinitionId' in value) || value['billingQuotaDefinitionId'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function BillingPackageQuotaOverrideFromJSON(json: any): BillingPackageQuotaOverride {
    return BillingPackageQuotaOverrideFromJSONTyped(json, false);
}

export function BillingPackageQuotaOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingPackageQuotaOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'billingQuotaDefinitionId': json['billingQuotaDefinitionId'],
        'value': json['value'],
        'billingQuotaDefinition': json['billingQuotaDefinition'] == null ? undefined : BillingQuotaDefinitionFromJSON(json['billingQuotaDefinition']),
    };
}

  export function BillingPackageQuotaOverrideToJSON(json: any): BillingPackageQuotaOverride {
      return BillingPackageQuotaOverrideToJSONTyped(json, false);
  }

  export function BillingPackageQuotaOverrideToJSONTyped(value?: BillingPackageQuotaOverride | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billingQuotaDefinitionId': value['billingQuotaDefinitionId'],
        'value': value['value'],
        'billingQuotaDefinition': BillingQuotaDefinitionToJSON(value['billingQuotaDefinition']),
    };
}

